module.exports = __webpack_public_path__ + "img/mcgl_fp_04.c4efc49b.png";